import React, { useRef } from 'react'
import { pick, isPlainObject } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import CollectorModal from '../../data-operate/Modal'

const MulCollector = ({ children }) => {
  const popupRef = useRef(null)
  const { fields, appendTbData, collectorConfig } = useTbViewStore((state) =>
    pick(state, ['fields', 'appendTbData', 'collectorConfig'])
  )

  const { getDitto } = useAppEx()
  const showLayouts = collectorConfig && collectorConfig.collectorLayouts

  const createData = (data, values, refSlugs, afterSubmit) => {
    const promiseArr = []
    const slugsArr = []
    refSlugs.forEach((v) => {
      const obj = fields.find((f) => f.slug === v)
      if (obj && getDitto(obj.dataFromTbId)) {
        promiseArr.push(getDitto(obj.dataFromTbId).createTbData(values[v]))
        slugsArr.push(v)
      }
    })

    return Promise.all(promiseArr).then((res) => {
      const props = {}
      slugsArr.forEach((v, index) => {
        props[v] = res[index].objectId
      })

      appendTbData({ ...data, ...props })
        .then(() => {
          afterSubmit()
        })
        .catch((err) => {
          if (!isPlainObject(err)) {
            showNotification({
              title: err,
            })
          }
        })
    })
  }

  const onClickSubmit = (data, afterSubmit, refValues) => {
    const refSlugs = fields.filter((v) => v.type === 'ref').map((v) => v.slug)
    createData(data, refValues, refSlugs, afterSubmit)
  }

  return (
    <CollectorModal
      ref={popupRef}
      title="新建数据"
      data={{}}
      fieldsLayouts={showLayouts}
      onConfirm={onClickSubmit}
      config={collectorConfig}
      trigger={children}
      isBatch
    />
  )
}
export default MulCollector
